(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bbt-device-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bbt-mobile-comparison')) {
  customElements.define('bbt-mobile-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.classList.contains('bbt-comparison--ready')) return;
      const table = this.querySelector('.bbt-comparison__table');
      const heads = table ? [...table.querySelectorAll('thead th')].slice(1) : [];
      if (heads.length < 2) return;
      const choices = [...this.querySelectorAll('[data-compare-choice]')];
      const rows = [...table.querySelectorAll('tbody tr')];
      const selected = [0, 1];
      const normalize = (text) => text.replace(/\s+/g, ' ').trim();
      const render = (announce = false) => {
        choices.forEach((choice, slot) => {
          [...choice.options].forEach((option) => { option.disabled = Number(option.value) === selected[1 - slot]; });
        });
        this.querySelector('[data-compare-products]').replaceChildren(...selected.map((index) => heads[index].querySelector('a').cloneNode(true)));
        const makeRow = (row) => {
          const values = selected.map((index) => row.cells[index + 1]);
          const different = normalize(values[0].textContent) !== normalize(values[1].textContent);
          const item = document.createElement('div');
          item.className = 'bbt-comparison__mobile-row';
          if (different) item.classList.add('bbt-comparison__mobile-row--different');
          if (row.classList.contains('bbt-comparison__price')) item.classList.add('bbt-comparison__mobile-row--price');
          const heading = document.createElement('h3');
          heading.textContent = row.cells[0].textContent;
          if (different) {
            const badge = document.createElement('span');
            badge.className = 'bbt-comparison__difference';
            badge.textContent = this.dataset.difference;
            heading.append(badge);
          }
          const pair = document.createElement('div');
          pair.className = 'bbt-comparison__pair';
          values.forEach((cell, slot) => {
            const value = document.createElement('div');
            const name = document.createElement('span');
            name.className = 'visually-hidden';
            name.textContent = heads[selected[slot]].querySelector('span').textContent + ': ';
            value.append(name, ...[...cell.childNodes].map((node) => node.cloneNode(true)));
            pair.append(value);
          });
          item.append(heading, pair);
          return item;
        };
        this.querySelector('[data-compare-main]').replaceChildren(...[rows[6], rows[0], rows[1], rows[2]].filter(Boolean).map(makeRow));
        this.querySelector('[data-compare-details]').replaceChildren(...rows.slice(3, 6).map(makeRow));
        this.querySelector('[data-compare-links]').replaceChildren(...selected.map((index) => rows[rows.length - 1].cells[index + 1].querySelector('a').cloneNode(true)));
        if (announce) this.querySelector('[data-compare-status]').textContent = this.dataset.updated + ' ' + selected.map((index) => heads[index].querySelector('span').textContent).join(' / ');
      };
      choices.forEach((choice, slot) => {
        heads.forEach((head, index) => {
          const option = document.createElement('option');
          option.value = String(index);
          option.textContent = head.querySelector('span').textContent;
          choice.append(option);
        });
        choice.value = String(selected[slot]);
        choice.addEventListener('change', () => { selected[slot] = Number(choice.value); render(true); });
      });
      render();
      this.querySelector('.bbt-comparison__mobile').hidden = false;
      this.classList.add('bbt-comparison--ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bbt-printer-advisor"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bbt-printer-advisor')) {
  customElements.define('bbt-printer-advisor', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const form = this.querySelector('form');
      const grid = this.querySelector('[data-grid]');
      const cards = [...this.querySelectorAll('[data-device]')];
      const strings = this.querySelector('[data-strings]').dataset;
      const summary = this.querySelector('[data-summary]');
      const pending = this.querySelector('[data-pending]');
      const status = this.querySelector('[data-status]');
      const results = this.querySelector('.bbt-advisor__results');
      const more = this.querySelector('[data-more]');
      const locale = document.documentElement.lang || 'de';
      const number = (value) => new Intl.NumberFormat(locale).format(value);
      let matches = [];
      let showAll = false;
      let current = null;
      const read = () => ({format: form.elements.format.value, color: form.elements.color.value, fn: form.elements.function.value, volume: Number(form.elements.volume.value) || 0, wifi: form.elements.wifi.checked});
      const sync = () => {
        const a3scan = form.elements.format.value === 'a3scan';
        const print = form.querySelector('[name="function"][value="print"]');
        print.disabled = a3scan;
        if (a3scan) form.querySelector('[name="function"][value="scan"]').checked = true;
        this.querySelector('[data-a3-function]').hidden = !a3scan;
      };
      const paint = () => {
        cards.forEach((card) => { card.hidden = true; });
        const visible = showAll ? matches : matches.slice(0, 3);
        visible.forEach((card) => { card.hidden = false; grid.append(card); });
        more.hidden = matches.length <= visible.length;
        this.querySelector('[data-empty]').hidden = matches.length > 0;
        const a3mono = current.format !== 'a4' && current.color === 'mono';
        this.querySelector('[data-a3-mono]').hidden = !a3mono;
        this.querySelector('[data-allow-color]').hidden = !a3mono;
        const countText = matches.length === 1 ? strings.single : strings.count.replace('[count]', number(matches.length));
        const shownText = visible.length === 1 ? strings.oneShown : strings.shown.replace('[shown]', number(visible.length));
        const count = matches.length ? countText + ' ' + shownText : strings.none;
        const volumeText = current.volume ? strings.known.replace('[volume]', number(current.volume)) : strings.unknown;
        const selection = [form.querySelector('[name="format"]:checked').closest('label').querySelector('strong').textContent, form.querySelector('[name="color"]:checked').closest('label').textContent.trim(), form.querySelector('[name="function"]:checked').closest('label').textContent.trim()];
        if (current.wifi) selection.push(form.querySelector('.bbt-advisor__wifi span').textContent);
        summary.textContent = count + ' ' + selection.join(' · ') + '. ' + volumeText;
      };
      const apply = (focus = false) => {
        sync();
        current = read();
        matches = cards.filter((card) => {
          const d = card.dataset;
          const formatMatch = current.format === 'a4' ? d.format === 'a4' : current.format === 'a3scan' ? d.format === 'a3scan' : d.format !== 'a4';
          return formatMatch && (current.color === 'any' || d.color === current.color) && d.function === current.fn && (!current.wifi || d.wifi === 'true') && (!current.volume || Number(d.volume) >= current.volume);
        }).sort((a, b) => Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true') || Number(a.dataset.price) - Number(b.dataset.price));
        showAll = false;
        pending.hidden = true;
        paint();
        status.textContent = summary.textContent;
        if (focus) {
          results.focus({ preventScroll: true });
          results.scrollIntoView({ block: 'start', behavior: 'instant' });
        }
      };
      form.addEventListener('submit', (event) => { event.preventDefault(); apply(true); }, options);
      const markPending = () => { sync(); pending.hidden = false; };
      form.addEventListener('change', markPending, options);
      form.elements.volume.addEventListener('input', markPending, options);
      form.addEventListener('reset', (event) => {
        event.preventDefault();
        for (const input of form.querySelectorAll('input')) {
          if (input.type === 'radio' || input.type === 'checkbox') input.checked = input.defaultChecked;
          else input.value = input.defaultValue;
        }
        apply();
      }, options);
      this.querySelectorAll('[data-volume]').forEach((button) => {
        if (button.tagName !== 'BUTTON') return;
        button.addEventListener('click', () => { form.elements.volume.value = button.dataset.volume; markPending(); }, options);
      });
      more.addEventListener('click', () => { showAll = true; paint(); status.textContent = summary.textContent; grid.querySelectorAll('[data-device]:not([hidden])')[3]?.querySelector('h3 a').focus(); }, options);
      this.querySelector('[data-allow-color]').addEventListener('click', () => { form.querySelector('[name="color"][value="color"]').checked = true; apply(true); }, options);
      form.hidden = false;
      apply();
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
